import { render, staticRenderFns } from "./SyncXDNsDialog.vue?vue&type=template&id=2019ea0d&"
import script from "./SyncXDNsDialog.vue?vue&type=script&lang=ts&"
export * from "./SyncXDNsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports